module.exports = __webpack_public_path__ + "static/media/a1.617f6789.jpg";